<template>
	<ConfigProvider :locale="locale">
		<Layout class="layout">
			<LayoutHeader class="header">
				<div class="logo" @click="onClickLogo">
					<img :src="logoImage" alt="Cors2Net" width="100px" />
				</div>
				<ClassicMenu
					:selectedKey="selectedMenuName"
					:items="userStore.menuItems"
					:rightKeys="rightKeys"
					@select="onMenuChange"
				/>
			</LayoutHeader>
			<LayoutContent class="main-container">
				<router-view v-slot="{ Component }">
					<transition name="fade" mode="out-in">
						<div :key="currentRouteKey">
							<component :is="Component" />
						</div>
					</transition>
				</router-view>
			</LayoutContent>
		</Layout>
	</ConfigProvider>
</template>

<script>
import ruRU from 'ant-design-vue/es/locale/ru_RU';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
dayjs.locale('ru');

import { computed } from 'vue';
import {
	ConfigProvider,
	Layout, LayoutHeader, LayoutContent,
} from 'ant-design-vue';

import { useRoute, useRouter } from 'vue-router';

import Api from '@/api/Api';

import { useUserStore } from '@/stores/user';
import { useRoversStore } from '@/stores/rovers';
import logoImage from '@/assets/logo.svg';

import ClassicMenu from '@/components/common/ClassicMenu';

const RIGHT_KEYS = ['login', 'registration', 'account', 'logout'];


export default {
	components: {
		ConfigProvider,
		Layout, LayoutHeader, LayoutContent,
		ClassicMenu,
	},
	setup() {
		const locale = computed(() => ruRU);
		const route = useRoute();
		const selectedMenuName = computed(() => route.name || 'home');
		const userStore = useUserStore();
		const roversStore = useRoversStore();

		const router = useRouter();
		const onMenuChange = itemKey => {
			if (itemKey === 'logout') {
				Api.logout();
				userStore.logout();
				roversStore.logout();
				router.push({ name: 'home' });
			} else {
				router.push({ name: itemKey });
			}
		};
		const onClickLogo = () => router.push({ name: 'home' });
		const currentRouteKey = computed(() => route.name || 'home');

		return {
			locale,
			userStore,
			selectedMenuName,
			rightKeys: RIGHT_KEYS,
			logoImage,
			currentRouteKey,
			onMenuChange,
			onClickLogo,
		}
	},
}
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.header {
	width: 100%;
	display: flex;
	position: sticky;
	z-index: 100;
	top: 0;
}

.logo {
	cursor: pointer;
	padding: 16px 24px;
	line-height: 1.5715;
	font-size: 20px;
	color: white;
	flex-shrink: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
